import { c as _c } from "react/compiler-runtime";
// The one empty state: an icon in a soft circle, a short title, one muted line; centred in what is left of its page.
// Styles: platform.css `.empty`.
import { Icon, type IconName } from "./icon";
export function Empty(t0) {
  const $ = _c(10);
  const {
    icon,
    title,
    text
  } = t0;
  let t1;
  if ($[0] !== icon) {
    t1 = <span className="empty-icon"><Icon name={icon} size={26} /></span>;
    $[0] = icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== title) {
    t2 = <b>{title}</b>;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== text) {
    t3 = text && <span className="muted">{text}</span>;
    $[4] = text;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <div className="empty" data-t="empty">{t1}{t2}{t3}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}